<template>
    <div>
        <b-modal id="modal-referral" centered no-close-on-backdrop @shown="getUserReferralLink" size="lg"
            :body-class="'px-3 pt-2 overflow-preview-auto'" no-close-on-esc :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
            :header-class="'align-items-center'" scrollable>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('referralSection.title') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="d-block text-center">
                <b-row>
                    <b-col sm="12" class="mt-2">
                        <b-form-group :label="$t('referralSection.shareLinkLabel')" label-for="check-user"
                            class="text-left label position-relative">
                            <b-form-input type="text" disabled v-model="referralLink" class="input"></b-form-input>
                            <svg @click="copyURL(referralLink)" class="copy-referrral-link cursor-pointer" width="15"
                                height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M9.84375 10.7813V12.8906C9.84375 13.2788 9.52875 13.5938 9.14062 13.5938H3.04688C2.86039 13.5938 2.68155 13.5197 2.54969 13.3878C2.41783 13.2559 2.34375 13.0771 2.34375 12.8906V4.92188C2.34375 4.53375 2.65875 4.21875 3.04688 4.21875H4.21875C4.53286 4.21854 4.84644 4.24446 5.15625 4.29625M9.84375 10.7813H11.9531C12.3412 10.7813 12.6562 10.4663 12.6562 10.0781V7.03125C12.6562 4.24375 10.6294 1.93063 7.96875 1.48375C7.65894 1.43196 7.34536 1.40604 7.03125 1.40625H5.85938C5.47125 1.40625 5.15625 1.72125 5.15625 2.10938V4.29625M9.84375 10.7813H5.85938C5.67289 10.7813 5.49405 10.7072 5.36219 10.5753C5.23033 10.4434 5.15625 10.2646 5.15625 10.0781V4.29625M12.6562 8.4375V7.26563C12.6562 6.70619 12.434 6.16966 12.0384 5.77407C11.6428 5.37849 11.1063 5.15625 10.5469 5.15625H9.60938C9.42289 5.15625 9.24405 5.08217 9.11219 4.95031C8.98033 4.81845 8.90625 4.63961 8.90625 4.45313V3.51563C8.90625 3.23862 8.85169 2.96432 8.74568 2.7084C8.63968 2.45248 8.4843 2.21995 8.28843 2.02407C8.09255 1.8282 7.86002 1.67282 7.6041 1.56682C7.34818 1.46081 7.07388 1.40625 6.79688 1.40625H6.09375"
                                    stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </b-form-group>
                    </b-col>
                    <b-col sm="12">
                        <hr class="my-2" />
                    </b-col>
                </b-row>
                <b-col sm="12" class="mt-2 px-0">
                    <h6 class="font-weight-bold text-left mb-2">{{ $t('referralSection.sendReferral') }}</h6>
                    <b-form-group :label="$t('referralSection.emailLabel')" label-for="check-user" class="text-left label">
                        <b-form-input type="email" v-model="email" class="input bg-white"></b-form-input>
                        <p v-if="errors && errors.email" class="field-error pb-2">
                            {{ errors.email[0] }}
                        </p>
                    </b-form-group>
                    <p class="f-14 text-left">{{ $t('referralSection.referralAmountNote') }}</p>
                </b-col>
            </div>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 mt-5">
                    <b-button class="mx-0 mr-3 h-40px w-100px m-0" @click="resetPopup()"
                        variant="secondary">{{ $t('referralSection.cancel') }}</b-button>
                    <div class="d-flex align-items m-0">
                        <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary"
                            @click="sendInvite">{{ $t('referralSection.invite') }}</b-button>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import { checkEmail } from '../../services/helper';
export default {
    name: "ReferralSection",
    data() {
        return {
            referralLink: "",
            email: "",
            errors: {},
            checkEmail
        }
    },
    methods: {
        ...mapActions(['getReferralLink', 'setLoader', 'setNotification']),
        resetPopup() {
            this.referralLink = ''
            this.email = ''
            this.errors = {}
            this.$bvModal.hide('modal-referral')
        },
        async getUserReferralLink() {
            this.setLoader(true)
            try {
                this.referralLink = await this.getReferralLink({})
                this.setLoader(false)
            }
            catch (e) {
                this.setLoader(false)
                console.log(e)
            }
        },
        async copyURL(url) {
            if (url) {
                try {
                    await navigator.clipboard.writeText(url);
                    await this.setNotification({
                        msg: this.$t('referralSection.linkCopied'),
                        type: "success",
                        color: "green",
                    });
                } catch (e) {
                    console.log(e)
                }
            }
        },
        async sendInvite() {
            try {
                this.errors = {}
                if (this.email) {
                    if (!this.checkEmail(this.email)) {
                        throw {
                            email: [this.$t('referralSection.wrongFormat')],
                        };
                    }
                }
                const nullKeys = this.checkNullValues({
                    email: this.email,
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    await this.getReferralLink({ invited_email: this.email });
                    await this.setNotification({
                        msg: this.$t('referralSection.invitationSent'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false)
                    this.resetPopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('referralSection.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                this.setLoader(false)
                if (typeof error === "object" && error.error) {
                    await this.setNotification({
                        msg: error.error,
                        type: "error",
                        color: "red",
                    });
                }
                else if (typeof error === "object") {
                    this.errors = error;
                }
            }
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (value === "") {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
    }
}
</script>
<style>
.copy-referrral-link {
    position: absolute;
    right: 10px;
    z-index: 10;
    top: 42px;
}
</style>